import { IFilter } from '../../types/filters';
import { FloorContainer } from '../../containers/advancedFilters/FloorContainer';

export const floor: IFilter = {
  component: FloorContainer,
};
